import { Link } from "react-router-dom";
import { Frown } from "lucide-react";

export default function NotFound() {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center vh-100 bg-light text-center px-3">
      <div>
        <Frown className="text-danger mb-4" size={80} />
        <h1 className="display-3 fw-bold text-dark">404</h1>
        <h2 className="fs-3 fw-semibold text-secondary">Página no encontrada</h2>
        <p className="mt-3 text-muted">
          Lo sentimos, parece que te perdiste. La página que buscas no existe o fue movida.
        </p>
        <div className="mt-4">
          <Link
            to="/"
            className="btn btn-danger btn-lg px-4 shadow-sm"
          >
            Volver al inicio
          </Link>
        </div>
      </div>
    </div>
  );
}